import React from "react";
import { TabController } from "./TabController";
import Creditor from "./Creditor";
import { CreditorTabType } from "../Types";

/**
 * @description - Tab container for creditor result view.
 * @author Tharanga Niroshana <tharangan@unicorn-solutions.com>
 * @since 12/01/2025
 * */
export const CreditorTab: React.FC<CreditorTabType> = (props) => {
  const {
    creditorData,
    tabInfo,
    isLoading,
    currentHit,
    totalCreditorSearchResult,
    paginationChangeEvent,
    changeSortOrderEvent,
  } = props;
  return (
    <TabController
      isLoading={isLoading}
      changeSortOrderEvent={changeSortOrderEvent}
      tabInfo={tabInfo}
    >
      <Creditor
        currentHit={currentHit}
        paginationChangeEvent={paginationChangeEvent}
        creditorData={creditorData}
        totalSearchResult={totalCreditorSearchResult}
      ></Creditor>
    </TabController>
  );
};
